export const SERVICE_TYPES = {
  WORK_SPACE: "فضای کار",
  MEETING_ROOM: "اتاق جلسات",
  CLASS: "دوره‌های آموزشی",
  EVENT: "رویداد",
  CONSULTATION: "مشاوره",
  HOLIDAY: "روز تعطیل",
};

export const SERVICE_STATUSES = {
  ACTIVE: {
    label: "فعال",
    color: "success",
  },
  PENDING_START: {
    label: "در انتظار شروع",
    color: "processing",
  },
  NEAR_EXPIRY: {
    label: "در آستانه انقضا",
    color: "warning",
  },
  EXPIRED: {
    label: "منقضی‌شده",
    color: "default",
  },
};

export const SERVICE_TYPE_OPTIONS = [
  { value: "WORK_SPACE", label: "فضای کار" },
  { value: "MEETING_ROOM", label: "اتاق جلسات" },
  { value: "CLASS", label: "دوره‌های آموزشی" },
  { value: "EVENT", label: "رویداد" },
  { value: "CONSULTATION", label: "مشاوره" },
  { value: "HOLIDAY", label: "روز تعطیل" },
];

export const SERVICE_STATUS_OPTIONS = [
  { value: "ACTIVE", label: "فعال" },
  { value: "PENDING_START", label: "در انتظار شروع" },
  { value: "NEAR_EXPIRY", label: "در آستانه انقضا" },
  { value: "EXPIRED", label: "منقضی‌شده" },
];

export const getRepurchaseLink = (item) => {
  if (!item || !item.serviceType) return "/services";

  switch (item.serviceType) {
    case "WORK_SPACE":
      return item.packageId
        ? `/services/workspace-single/${item.packageId}`
        : "/services/work-spaces";
    case "MEETING_ROOM":
      return item.packageId
        ? `/services/meeting-room-single/${item.packageId}`
        : "/services/meeting-rooms";
    case "CONSULTATION":
      return item.productId
        ? `/services/consultation-single/${item.productId}`
        : "/services/consulting";
    case "HOLIDAY":
      return "/services/holiday";
    case "CLASS":
      return item.productId
        ? `/classes/classes-single/${item.productId}`
        : "/services";
    case "EVENT":
      return item.productId
        ? `/events/events-single/${item.productId}`
        : "/services";
    default:
      return "/services";
  }
};

export const isRenewalDisabled = (item) => {
  if (!item || !item.serviceType) return false;
  return item.serviceType === "CLASS" || item.serviceType === "EVENT";
};

export const getRenewalDisabledReason = (item) => {
  if (!isRenewalDisabled(item)) return null;
  if (item.serviceType === "CLASS") {
    return "امکان تمدید دوره‌های آموزشی وجود ندارد.";
  }
  if (item.serviceType === "EVENT") {
    return "امکان تمدید رویدادها وجود ندارد.";
  }
  return "امکان تمدید این خدمت وجود ندارد.";
};
